module.exports = __webpack_public_path__ + "img/ICON_1.b8b92351.png";